import { useIntl } from 'react-intl';
import { Button } from '@openedx/paragon';
import { formatProgramType } from '../utils';
import { StartButtonProps } from './types';

export const StartButton = ({
  program,
  courseURL,
  ...props
}: StartButtonProps) => {
  const { formatMessage } = useIntl();

  const renderCourseStartButton = () => (
    <Button variant="brand" as="a" href={courseURL} {...props}>
      {formatMessage({
        id: 'payment.thankyou.product.start.course',
        defaultMessage: 'Start course',
        description: 'CTA to start the course after successful payment',
      })}
    </Button>
  );

  const renderProgramStartButton = () => {
    const programUrl = `${
      process.env.NEXT_PUBLIC_EDX_LMS_BASE_URL! +
      process.env.NEXT_PUBLIC_EDX_LMS_PROGRAM_DASHBOARD_PATH! +
      program!.productKey!
    }/`;

    return (
      <Button variant="brand" as="a" href={programUrl} {...props}>
        {formatMessage(
          {
            id: 'payment.thankyou.product.start.program',
            defaultMessage: 'Start the {programType}',
            description: 'CTA to start the program after successful payment',
          },
          // @ts-expect-error programType is valid
          { programType: formatProgramType(program.attributes?.type) },
        )}
      </Button>
    );
  };

  return program ? renderProgramStartButton() : renderCourseStartButton();
};
